import React from 'react';
import Component from '../../components/Component';
import {connect} from 'react-redux';
import * as tabActions from '../../redux/modules/tabs';
import {bindActionCreators} from 'redux';
import {Datagrid} from 'reactis-datagrid';
import Renderer from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import ProblemForm from "./ProblemForm";
import {ModalWindow} from 'reactis-modal';
import config from "../../config";
import EventEmitter from "../../EventEmitter";

@connect(null,
	(dispatch) => {
		return {actions: bindActionCreators(tabActions, dispatch)};
	})
export default class RowDetail extends Component {

	static contextTypes = {
		user: React.PropTypes.object.isRequired,
		store: React.PropTypes.object,
		flashMessage: React.PropTypes.func
	};

	handleAddClick(e) {
		e.preventDefault();
		this.popupDriver = new ModalWindow(null, <ProblemForm id={this.props.data.get('id')}
															  onSave={(data) => this.handleAddProblem(data)} />);
		this.popupDriver.className = 'fullwidth';
		this.popupDriver.show(this.context.store.dispatch);
	}

	handleAddProblem(data) {
		config.getApiClient.call('checkpoint.newProblem', {data: data, id: this.props.data.get('id')}).then(() => {
			this.popupDriver.hide();
			//this.props.onAdd(data.rating, this.props.data.get('title') + ' - ' + data.title);
			//this.props.onSave(data);
			EventEmitter.emit('checkpoint.change');
		});
	}

	handleDeleteProblem(id) {
		config.getApiClient.call('checkpoint.deleteProblem', {id}).then(() => {
			EventEmitter.emit('checkpoint.change');
		});
	}

	render() {

		const columnModel = [
			{
				name: 'rating',
				title: 'Úroveň',
				field: 'rating',
				sortable: false,
				width:40,
				renderer: (val, row) => {
					if (this.props.picker) {
						return <div style={{cursor:'pointer'}} onClick={() => this.props.onAdd(row.rating, this.props.data.get('title') + ' - ' + row.title, this.props.data.get('id'))}>{Renderer.DbInfo.call(DbInfo.Rating, val)}</div>
					}
					return Renderer.DbInfo.call(DbInfo.Rating, val);
				}
			},
			{
				name: 'title',
				title: 'Problém',
				field: 'title',
				sortable: false,
				renderer: (val, row) => {
					if (this.props.picker) {
						return <div style={{cursor:'pointer'}} onClick={() => this.props.onAdd(row.rating, this.props.data.get('title') + ' - ' + row.title, this.props.data.get('id'))}>{val}</div>
					}
					return val;
				}
			},
			{
				name: 'remove',
				title: '',
				field: 'id',
				width: 14,
				sortable: false,
				renderer: (val, row) => {
					return <i onClick={() => this.handleDeleteProblem(val)} title="Odstranit" className="icon-cross" style={{cursor:'pointer'}}></i>;
				}
			}
		];

		return (
			<div style={{width: '100%'}}>
				<Datagrid
					columnModel={columnModel}
					emptyText="Kontrolní bod neobsahuje žádné závady."
					rows={this.props.data.get('items')}
				/>
				<div style={{marginTop: 5, marginLeft: 5}}>
					<a href="#" onClick={(e) => this.handleAddClick(e)}><i className="fa fa-plus position-left"/>přidat závadu</a>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Checkpoint/RowDetail.js